import common from '@/common';
import { downloadBlob } from '@/utils/utils';
import { request } from '@umijs/max';
import { uniqueId } from 'lodash';
import { getOneTimeChargeList } from './utils';
// import { isEmpty, omit } from 'lodash';

// 查询member列表
export async function queryMemberService(data: any) {
  return request(`/bcare/member/listByCustId`, {
    method: 'POST',
    data,
  }).then((res) => ({
    list: res?.list.map((el: any) => {
      if (el.childSubsDtoList) {
        el.childSubsDtoList = el.childSubsDtoList.map((item: any) => ({
          ...item,
          bundleOfferId: el?.subsPlan?.offerId,
          rowKey: `${item.memberId}-${uniqueId()}`,
          bundleSubsAgreement: el?.agreementInsts || [],
        }));
      }
      return { ...el, rowKey: `${el.memberId}-${uniqueId()}` } || [];
    }),
    total: res?.total,
  }));
}

// 查询订户详情
export async function queryMemberResource(memberId: number, params: any) {
  return request(
    common?.projectCode === 'pto'
      ? `/bcare/bcc/bcMember/detail/${memberId}`
      : `/bcare/member/detail/${memberId}`,
    {
      params,
    },
  );
}

// 查询配置项接口
export async function getSysparam(params: any) {
  return request(`/bcare/sysparam`, {
    params,
  });
}

// 固网offer订购vas
export async function orderVas(data: any) {
  return request('/bcare/member/vas', {
    method: 'POST',
    data,
  });
}

// 非固网offer订购vas
export async function changeVasSubmit(data: any) {
  return request('/bcare/member/setvas', {
    method: 'POST',
    data,
  });
}

// 查询二次业务按钮服务类型列表，用于页面按钮的展示和隐藏(按字母排序)
export async function qrySubsEventServTypeService(params: any) {
  return request('/bcare/subsevent', {
    params,
  }).then((res) =>
    (res?.subsEventServTypeList || []).sort((a: any, b: any) =>
      a.subsEventName.trim().localeCompare(b.subsEventName.trim()),
    ),
  );
}

// 导出member list
export async function exportMemberService(data: any) {
  return request('/bcare/member/list/export', {
    method: 'POST',
    data,
    responseType: 'blob',
  }).then((res) => {
    const fileType = data.fileFormat === 'CSV' ? 'text/csv' : 'text/plain';
    downloadBlob(
      res,
      fileType,
      `Member List.${data.fileFormat.toLocaleLowerCase()}`,
    );
  });
}

// 二次业务相关接口
// 查询角色
export async function queryRoleService(params: any) {
  return request(`/bcare/role/query/condition`, {
    params,
  });
}

// 获取订户详情
export async function getNumberInfoService(params: { serviceNumber: string }) {
  return request(`/bcare/subs/accnbr`, {
    params,
  });
}

// 新增bm成员
export async function addBmMemberService(data: any) {
  return request('/bcare/member/add', {
    method: 'POST',
    data,
  });
}

// 查询可订购的offer列表
export async function queryOfferService(data: any) {
  return request('/bcare/offer/productoffering', {
    method: 'POST',
    data,
  });
}

// 查询语言
export async function getLanguageService() {
  return request(`/bcare/member/language/list`);
}

// 修改语言非g网
export async function changeLanguageService(data: any) {
  return request('/bcare/member/subslanguage/modify', {
    method: 'POST',
    data,
  });
}

// 修改语言 g网
export async function batchChangeLanguageService(data: any) {
  return request('/bcare/member/language/modify', {
    method: 'POST',
    data,
  });
}

// 修改号码 二次服务
export async function numberShiftingService(data: any) {
  return request('/bcare/member/numberShifting', {
    method: 'POST',
    data,
  });
}

// 删除bm成员
export async function deleteBmMemberService(data: any) {
  return request('/bcare/member/delete', {
    method: 'POST',
    data,
  });
}

// 修改代付账单
export async function modifyBillService(data: any) {
  return request('/bcare/member/modify', {
    method: 'POST',
    data,
  });
}

// check change offer
export async function checkChangeOfferService(data: any) {
  return request('/bcare/member/batch/subsplan/check', {
    method: 'POST',
    data,
  });
}

// change offer
export async function changeOfferService(data: any) {
  return request('/bcare/member/batch/subsplan/submit', {
    method: 'POST',
    data,
  });
}

// change bundle member offer
export async function changeBundleMemberOfferService(data: any) {
  return request('/bcare/member/changoffer', {
    method: 'POST',
    data,
    timeout: 120000,
  });
}

// 查询停复机原因
export async function querySuspendReasonService(subseventId: string) {
  return request(`/bcare/order/orderreason/${subseventId}`);
}

// 停复机check
export async function checkombysubsEventService(data: any) {
  return request('/bcare/member/batch/checkombysubsevent', {
    method: 'POST',
    data,
  });
}

// 批量复机
export async function batchReactiveService(data: any) {
  return request('/bcare/member/batch/reactive', {
    method: 'POST',
    data,
  });
}

// 批量停机
export async function batchSuspendService(data: any) {
  return request('/bcare/member/batch/suspend', {
    method: 'POST',
    data,
  });
}

// // 自动选号
// export async function autoSelectNumberService() {
//   return request('/bcare/member/selectNumber', {
//     method: 'POST',
//     data: {
//       autoFlag: true
//     }
//   });
// }

// 查询选号
export async function querySelectNumberService(data: any) {
  return request('/bcare/member/selectNumber', {
    method: 'POST',
    data,
  });
}

// bundle查询选号
export async function queryNumberForBundleService(data: any) {
  return request('/bcare/member/selectNumber-bundle', {
    method: 'POST',
    data,
  });
}

// bundle二次业务相关接口
// 选择地址查询state
export async function getStateService(params: any) {
  return request('/bcare/tableWithCondition', {
    params,
  }).then((res) => {
    if (res?.tableColumnList?.length) {
      return (res?.tableColumnList || [])?.map((item: any) => ({
        label: item.VALUE_MARK,
        value: item.ATTR_VALUE_ID + ',' + item.VALUE,
      }));
    }
  });
}

// 查询地址
export async function getChooseAddressService(params: any) {
  return request('/bcare/addressSearchByKeyword', {
    params,
  }).then((res) => res?.data || []);
}

// 新增TT order
export async function addTicketOrderService(data: any) {
  return request('/bcare/ticket/order/add', {
    method: 'POST',
    data,
  });
}

// 地址勘察列表
export async function getAddressAvailabilityCheckService(data: any) {
  return request('/bcare/address/availability-check', {
    method: 'POST',
    data,
  });
}

// prefication 参数校验
export async function preficationMultiCheckService(data: any) {
  return request('/bcare/order/preverification-multi', {
    method: 'POST',
    data,
  });
}

// 新增联系人
export async function addContactService(data: any) {
  return request('/bcare/bizcust/contact', {
    method: 'POST',
    data,
  });
}

// 查询bundle套餐
export async function queryBundleMemberService(offerId: any, data: any) {
  return request(`/bcare/offer/detail/${offerId}`, {
    method: 'POST',
    data,
  }).then((res) => {
    return res?.bundledProductOffering || [];
  });
}

// 查询offer detail
export async function queryOfferDetailService(offerId: any, data: any) {
  return request(`/bcare/offer/detail/${offerId}`, {
    method: 'POST',
    data,
  }).then((res) => {
    return res;
  });
}

// 查询subsInfo套餐
export async function queryMemberSubsInfoService(params: any) {
  return request(`/bcare/subs/id`, {
    params,
  }).then((res) => res?.attrs);
}

// 查询联系人
export async function getContactService(params: any) {
  return request(`/bcare/contactMan/${params.custId}`).then(
    (res) => res?.contacts || [],
  );
}

// /bcare/order/changeBundleOffer  下订单接口
export async function changeBundleOfferService(data: any) {
  return request(`/bcare/order/changeBundleOffer`, {
    method: 'POST',
    data,
    timeout: 120000,
  });
}

// /bcare/order/relocation  下订单接口
export async function relocationService(data: any) {
  return request(`/bcare/order/relocation`, {
    method: 'POST',
    data,
    timeout: 120000,
  });
}

// 查询余额
export async function queryBalInfoService(data: any) {
  return request(`/bcare/usage/queryBalInfo`, {
    method: 'POST',
    data,
  });
}

// 查询欠费
export async function queryBusinessFeeService(data: any) {
  return request(`/bcare/um/member/qry/reactive/fee`, {
    method: 'POST',
    data,
  });
}

// 查询号码等级
export async function queryNumberGradeService() {
  return request(`/bcare/member/number-grades`, {});
}

// 换号check
export async function checkMisidnService(data: any, eventId: any) {
  return request(
    `${eventId === 32 ? '/bcare/member/change/msisdn/precheck' : '/bcare/member/change/sim/precheck'}`,
    {
      method: 'POST',
      data,
    },
  );
}

// 换卡
export async function changeSimCardService(data: any) {
  return request(`/bcare/member/duplicatesimcard`, {
    method: 'POST',
    data,
  });
}

// 批量订购可选包
export async function batchBuyVasService(data: any) {
  return request(`/bcare/member/batch/vas`, {
    method: 'POST',
    data,
  });
}

// 开户
export async function newConnectionService(data: any) {
  return request(`/bcare/member/newconnection`, {
    method: 'POST',
    data,
  });
}

// um 查询新套餐
export async function queryChangeOffersService(params: any) {
  return request(`/bcare/offer/available-mainoffers`, {
    params,
  });
}

// 修改备注信息
export async function changeCommentsService(data: any) {
  return request(`/bcare/member/comments`, {
    method: 'POST',
    data,
  });
}

// 合约详情
export async function queryAgreementService(params: any) {
  return request(`/bcare/subs/id`, {
    params,
  }).then((res) => res?.agreementInsts || []);
}
// 主产品信息
export async function queryIndepProdService(params: any) {
  return request(`/bcare/subs/id`, {
    params,
  });
}

// 校验号码在新地址是否可用
export async function numberCheckExchangeService(data: any) {
  return request(`/bcare/installation/number-check-exchange`, {
    method: 'POST',
    data,
  });
}

// 查询TNC
export async function getTncService(data: any) {
  return request(`/bcare/installation/querytnc`, {
    method: 'POST',
    data,
  }).then((res) => res?.result || {});
}

// 查询offer配置图片
export async function getOfferImgService(params: any) {
  return request(`/bcare/offer/queryOfferImage?offerId=${params?.offerId}`, {
    timeout: 60000,
  }).then((res) => res?.list || []);
}

// 查询offer详情
export async function getOfferDetailService(
  offerId: number | string,
  data: any,
) {
  return request(`/bcare/offer/detail/${offerId}`, {
    method: 'POST',
    data,
  });
}

// 查询demandCase单
export async function getDemandCaseService(data: any) {
  return request(`/bcare/ticket/qryDemandCase`, {
    method: 'POST',
    data,
  });
}

// 创建demand case
export async function getCreateDemandService(data: any) {
  return request(`/bcare/ticket/order/add`, {
    method: 'POST',
    data,
  });
}

// 查询Premise Category
export async function getPremiseCategoryService(data: any) {
  return request('/bcare/ticket/attr', {
    method: 'POST',
    data,
  }).then((res) => {
    if (res?.resultObject?.attrList[0]?.attrValueList.length > 0) {
      return (res?.resultObject?.attrList[0]?.attrValueList || [])?.map(
        (item: any) => ({
          ...item,
          label: item.attrValueName,
          value: item.attrValue,
        }),
      );
    }
  });
}

// 查询安装类型
export async function queryInstallationTypeService(data: any) {
  return request(`/bcare/installation/type`, {
    method: 'POST',
    data,
  });
}

// 查询地址 bcare/address/qryAddrByPostCode
export async function queryAddressService(data: any) {
  return request('/bcare/address/qryAddrByPostCode', {
    method: 'POST',
    data,
  });
}

// 查询rush order
export async function queryRushOrderService(data: any) {
  return request('/bcare/installation/rush-orders', {
    method: 'POST',
    data,
  });
}

// 查询时间片bcare/installation/queryslot
export async function querySlotService(data: any) {
  return request('/bcare/installation/queryslot', {
    method: 'POST',
    data,
  });
}

// 查询bundle套餐
export async function queryOfferAttributeService(offerId: any, data: any) {
  return request(`/bcare/offer/detail/${offerId}`, {
    method: 'POST',
    data,
  }).then((res) => {
    return res?.offerAttribute || [];
  });
}

// 查询SendBookingInfo
export async function querySendBookingInfoService(data: any) {
  return request(`/bcare/order/sendBookingInfo`, {
    method: 'POST',
    data,
    timeout: 120000,
  });
}

// modify offer
export async function modifyOfferService(data: any) {
  return request(`/bcare/member/vas`, {
    method: 'POST',
    data,
  });
}

// 查询可选包的互斥关系接口
export async function queryOfferRela(data: any) {
  return request(`/bcare/offer/rela`, {
    method: 'POST',
    data,
  });
}

// 查询bundle套餐的合约信息
export async function querySubsAgreementService(data: any) {
  return request(`/bcare/agreement/list`, {
    method: 'POST',
    data,
  }).then((res) => res?.agreementList || []);
}

// 移机查询地址详情
export async function queryAddressSearchByLatLonService(data: any) {
  return request(`/bcare/address/addressSearchByLatLon`, {
    method: 'POST',
    data,
  }).then((res) => res?.addressList?.[0] || []);
}

// 校验demand case
export async function queryCheckCreateFixDemandCaseService(data: any) {
  return request(`/bcare/ticket/checkCreateFixDemandCase`, {
    method: 'POST',
    data,
  });
}

// 销售实物场景
export async function queryGoodsStockService(data: any) {
  return request(`/bcare/offer/goods/stocks`, {
    method: 'POST',
    data,
  });
}

// 查询bundle子成员套餐（当前仅对bundle子成员做买包使用）
export async function queryModifyOfferService(offerId: any, data: any) {
  // 发送请求获取 offer 详情
  const res = await request(`/bcare/offer/detail/${offerId}`, {
    method: 'POST',
    data,
  });

  // 查询产品服务
  const resData: any = await queryOfferService({
    productOfferingType: [2],
    channel: 18,
    isBundleFlag: 'Y',
    offerAttrCode: 'TM_BCARE_FILTER_DPOFFER',
    offerAttrDefaultValue: 'Y',
  });

  // 提取 resData 中的 id
  const excludedIds = new Set(
    resData?.productOffering?.map((offering: any) => offering.id),
  );

  const result: any[] = [];
  let resultWithStockList: any[] = [];

  // 处理 productOfferingRelationship
  res?.productOfferingRelationship?.forEach((relationship: any) => {
    relationship?.groupProductOfferingRela?.forEach((group: any) => {
      group?.offerGroupMember?.forEach((member: any) => {
        const {
          memOfferName,
          memSaleListPrice,
          memRentListPrice,
          memOfferId,
          memOfferCode,
          prodType,
          hideMode,
        } = member;

        // 过滤默认资费组和已排除的 id和 hideMode不为空，并且第一位数字是0(hideMode为cpc配置)
        if (
          group?.offerGroupType !== '6' &&
          !excludedIds.has(memOfferId) &&
          !/^(0[0-9]*|0)$/.test(hideMode)
        ) {
          result.push({
            id: memOfferId,
            name: memOfferName,
            code: memOfferCode,
            saleListPrice: memSaleListPrice,
            rentListPrice: memRentListPrice,
            prodType: prodType,
            isBundleFixedMember: 'Y', // 标识当前是固网子成员
          });
        }
      });
    });
  });

  const resultWithProdType = result?.filter((item) => item?.prodType === '5');
  // 把返回的list中包含prodType=5的都收集到一个新的list，调实物接口
  const offerList = resultWithProdType?.map((item: any) => {
    return {
      offerId: item?.id,
      // modelId: '', // bundle子成员固网类型没有modalId，所以不传
    };
  });

  if (resultWithProdType?.length > 0) {
    const goodsOfferResult = await queryGoodsStockService({
      offerList,
      needQryModelId: 'Y',
    });

    // 根据offerId寻找result和goodsOffers相同的数据，将goodsOffers数组中qty添加到result对应的offerId对象内
    resultWithStockList = result?.map((item) => {
      const temp: any = { ...item };
      const goodsOffer = goodsOfferResult?.offerList?.find(
        (goodsItem: any) => goodsItem?.offerId === item?.id,
      );

      // 兼容qty可以为0的场景
      if (goodsOffer?.qty || goodsOffer?.qty === 0) {
        temp.qty = goodsOffer?.qty;
      }
      return temp;
    });
  } else {
    resultWithStockList = result; // 当前没有prodType为5的场景，则走正常流程，直接返回result
  }

  return resultWithStockList;
}

// 新增可选包时查询可新增的可选包列表
export async function querySelectOfferService(offerId: any, data: any) {
  // 发送请求获取 offer 详情
  const res = await request(`/bcare/offer/detail/${offerId}`, {
    method: 'POST',
    data,
  });

  // 查询产品服务
  const resData: any = await queryOfferService({
    productOfferingType: [2],
    channel: 18,
    isBundleFlag: 'Y',
    offerAttrCode: 'TM_BCARE_FILTER_DPOFFER',
    offerAttrDefaultValue: 'Y',
  });

  // 提取 resData 中的 id
  const excludedIds = new Set(
    resData?.productOffering?.map((offering: any) => offering.id),
  );

  const result: any[] = [];
  let resultWithStockList: any[] = [];

  // 处理 productOfferingRelationship
  res?.productOfferingRelationship?.forEach((relationship: any) => {
    relationship?.groupProductOfferingRela?.forEach((group: any) => {
      group?.offerGroupMember?.forEach((member: any) => {
        const {
          memOfferName,
          memSaleListPrice,
          memRentListPrice,
          memOfferId,
          memOfferCode,
          prodType,
          hideMode,
        } = member;

        // 过滤默认资费组和已排除的 id和 hideMode不为空，并且第一位数字是0(hideMode为cpc配置)
        if (
          group?.offerGroupType !== '6' &&
          !excludedIds.has(memOfferId) &&
          !/^(0[0-9]*|0)$/.test(hideMode)
        ) {
          result.push({
            id: memOfferId,
            name: memOfferName,
            code: memOfferCode,
            saleListPrice: memSaleListPrice,
            rentListPrice: memRentListPrice,
            prodType: prodType,
            isBundleFixedMember: 'Y', // 标识当前是固网子成员
          });
        }
      });
    });
  });

  const resultWithProdType = result?.filter((item) => item?.prodType === '5');
  // 把返回的list中包含prodType=5的都收集到一个新的list，调实物接口
  const offerList = resultWithProdType?.map((item: any) => {
    return {
      offerId: item?.id,
      // modelId: '', // bundle子成员固网类型没有modalId，所以不传
    };
  });

  if (resultWithProdType?.length > 0) {
    const goodsOfferResult = await queryGoodsStockService({
      offerList,
      needQryModelId: 'Y',
    });

    // 根据offerId寻找result和goodsOffers相同的数据，将goodsOffers数组中qty添加到result对应的offerId对象内
    resultWithStockList = result?.map((item) => {
      const temp: any = { ...item };
      const goodsOffer = goodsOfferResult?.offerList?.find(
        (goodsItem: any) => goodsItem?.offerId === item?.id,
      );

      // 兼容qty可以为0的场景
      if (goodsOffer?.qty || goodsOffer?.qty === 0) {
        temp.qty = goodsOffer?.qty;
      }
      return temp;
    });
  } else {
    resultWithStockList = result; // 当前没有prodType为5的场景，则走正常流程，直接返回result
  }

  // 为resultWithStockList添加所属组信息
  const transformOfferData = (res: any, resultWithStockList: any) => {
    // 提取 productOfferingRelationship 中的 groupProductOfferingRela
    const groupProductOfferingRela = res.productOfferingRelationship
      .map((relationship: any) => relationship.groupProductOfferingRela)
      .flat();

    // 创建最终结果数组
    const finalResult = groupProductOfferingRela.map((group: any) => {
      // 提取组成员
      const offerGroupMembers = group.offerGroupMember
        .map((member: any) => {
          // 在 resultWithStockList 中查找与当前成员对应的数据
          const stockItem = resultWithStockList.find(
            (item: any) => item.id === member.memOfferId,
          );
          // 返回当前成员数据，并合并库存信息
          if (stockItem) {
            return {
              id: member.memOfferId,
              name: member.memOfferName,
              code: member.memOfferCode,
              offerId: member.memOfferId,
              offerName: member.memOfferName,
              offerCode: member.memOfferCode,
              saleListPrice: member.memSaleListPrice,
              rentListPrice: member.memRentListPrice,
              prodType: member.prodType,
              isBundleFixedMember: 'Y', // 标识当前是固网子成员
              ...(stockItem ? { qty: stockItem.qty } : {}), // 如果存在库存信息则添加
            };
          } else {
            return null;
          }
        })
        .filter((member: any) => member !== null); // 过滤掉 null

      // 返回组数据
      return {
        groupId: group.groupId,
        groupName: group.groupName,
        groupType: group.groupType,
        effDate: group.effDate,
        offerGroupMember: offerGroupMembers,
        offerGroupType: group.offerGroupType,
        ...(group.upperLimit ? { upperLimit: group.upperLimit } : {}), // 仅在存在 upperLimit 时添加
        ...(group.lowerLimit ? { lowerLimit: group.lowerLimit } : {}), // 仅在存在 lowerLimit 时添加
      };
    });

    return finalResult;
  };
  return transformOfferData(res, resultWithStockList);
}

// 校验二次业务菜单初始化验证
export async function queryCheckSubscriberEligibilityService(data: any) {
  return request(`/bcare/tm/order/checkSubscriberEligibility`, {
    method: 'POST',
    data,
  });
}

// 计算一次性费用
export async function queryOneTimeChargeService(data: any) {
  return request(`/bcare/order/calculatefee`, {
    method: 'POST',
    data,
  }).then((res) => ({
    oneTimeChargeList: getOneTimeChargeList(res?.formatFeeDetail),
    totalOtcPrice: res?.totalOtcPrice,
  }));
}

// 计算月租费用
export async function queryMonthlyChargeService(data: any) {
  return request(`/bcare/order/calculateMonthlyfee`, {
    method: 'POST',
    data,
  });
}

// 修改联系人
export async function modContactService(data: any) {
  return request('/bcare/bizcust/mod/contact', {
    method: 'POST',
    data,
  });
}

// 预校验Bundle订户套餐切换
export async function checkChangeBundleOfferEligibilityService(data: any) {
  return request('/bcare/order/checkChangeBundleOfferEligibility', {
    method: 'POST',
    data,
  });
}

// change bundle member下订单接口
export async function changeBundleMemberService(data: any) {
  return request('/bcare/order/changeBundleMember', {
    method: 'POST',
    data,
    timeout: 120000,
  });
}

// 预校验Bundle订户套餐切换
export async function checkChangeOfferEligibilityService(data: any) {
  return request('/bcare/order/checkChangeOfferEligibility', {
    method: 'POST',
    data,
  });
}

// 预校验可选包订购/退订（189事件）
export async function checkSelectOfferEligibilityService(data: any) {
  return request('/bcare/order/checkSetVassEligibility', {
    method: 'POST',
    data,
  });
}

// 预校验可选包订购/退订(change offer 329事件)
export async function checkSubsplanEligibilityService(data: any) {
  return request('/bcare/order/checkSubsplanEligibility', {
    method: 'POST',
    data,
  });
}

// change bundle member / change bundle offer新装校验特殊服务类型是否可选号
export async function checkAutoCreateAccNbrByServTypeService(params: any) {
  return request(
    `/bcare/member/checkAutoCreateAccNbrByServType?servType=${params?.servType}`,
  );
}

// 查询sim卡类型
export async function querySimTypeService(data: any) {
  return request('/bcare/res/simcard/type', {
    method: 'POST',
    data,
  }).then((res) => res?.bcareSimCardTypeDtos);
}

// 查询卡信息
export async function querySimInfoService(subsId: any) {
  return request(`/bcare/subs/subsrelasim/${subsId}`);
}

// 换卡下单接口
export async function simcardEligibilityService(data: any) {
  return request(`/bcare/order/checkChangeSimcardEligibility`, {
    method: 'POST',
    data,
  });
}

// 换卡下单接口
export async function simReplacementService(data: any) {
  return request(`/bcare/order/simReplacement`, {
    method: 'POST',
    data,
  });
}

// 批量激活下订单
export async function batchActivationService(data: any) {
  return request('/bcare/member/batchActivation', {
    method: 'POST',
    data,
  });
}

// 批量sim replacement 查询sku
export async function batchSimReplacementQuerySkuService(params: any) {
  return request('/bcare/simType/sku', {
    params,
  }).then((res) => {
    return res?.simTypeAndSkuDtoList || [];
  });
}

// 批量sim replacement 查询卡类型接口
export async function batchSimReplacementQueryCardTypeService(params: any) {
  return request('/bcare/simType/batchQuery', {
    params,
  }).then((res) => res?.simCardList || []);
}

// 批量sim replacement check
export async function batchSimReplacementCheckService(data: any) {
  return request('/bcare/member/batchSimReplacement/check', {
    method: 'POST',
    data,
  });
}

// 批量sim replacement 下单
export async function batchSimReplacementSubmitService(data: any) {
  return request('/bcare/member/batchSimReplacement/submit', {
    method: 'POST',
    data,
  });
}

// 批量卡挂失
export async function batchSimLostService(data: any) {
  return request('/bcare/member/batch/simLost', {
    method: 'POST',
    data,
  });
}

// 批量解卡挂失
export async function batchSimRestoreService(data: any) {
  return request('/bcare/member/batch/simRestore', {
    method: 'POST',
    data,
  });
}

// 批量转换部门
export async function batchMigrateDepartmentCheckService(data: any) {
  return request('/bcare/member/batchMigrateDepartment/check', {
    method: 'POST',
    data,
  });
}

// 批量转换部门提交
export async function batchMigrateDepartmentSubmitService(data: any) {
  return request('/bcare/member/batchMigrateDepartment/submit', {
    method: 'POST',
    data,
  });
}
